angular.module('backOffice').directive('viewOnlyForSupport', [
    'entitlementsService',
    function (entitlementsService) {
        return {
            link(scope, element) {
                function checkEntitlement() {
                    if (entitlementsService.hasEntitlement('Switch FI')) {
                        element.addClass('support-disabled');
                    } else {
                        element.removeClass('support-disabled');
                    }
                }

                checkEntitlement();

                scope.$on('entitlementsSet', checkEntitlement);
            },
        };
    },
]);
